// import AppBar from '@mui/material/AppBar';
// import Box from '@mui/material/Box';
// import Toolbar from '@mui/material/Toolbar';
// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
// import MenuIcon from '@mui/icons-material/Menu';
// import Container from '@mui/material/Container';
// import Button from '@mui/material/Button';
// import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
// import { MyMenu } from "./MyMenu/MyMenu";
// import MyBtn from "../../UI/MyBtn/MyBtn";
// import { MobileMenu } from "./MobileMenu/MobileMenu";
// import { Link } from 'react-router-dom';
// import { Avatar, Badge, Theme, useMediaQuery } from "@mui/material";
// import avatar_img from "../../../public/avatar.png";
// import { ProfileMenu } from "./ProfileMenu/ProfileMenu";
// import { useSelector } from 'react-redux';
// import { RootState } from "../../../store/store";
// import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
// import NotificationsIcon from '@mui/icons-material/Notifications';
// import React, { useState, MouseEvent } from 'react';
// import VerifiedIcon from "@mui/icons-material/Verified";
// import { useTranslation } from 'react-i18next';
// import useChangeLanguage from "../../../hooks/useChangeLanguage";
// import PinDropIcon from '@mui/icons-material/PinDrop';
// import { styled } from '@mui/system';
// import imgIcon from '../../../public/main/R.svg'

// export const NavBar = () => {
//     const { t, i18n } = useTranslation();
//     const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

//     const pages = [

//         {
//             id: '/about',
//             name: t('navBar.about'),
//             path: `${i18n.language}/about`,
//         },
//         {
//             id: `/pricing`,
//             name: t('navBar.pricing'),
//             path: `${i18n.language}/pricing`,
//         },
//         {
//             id: '/bloglist',
//             name: "Blog",//t('navBar.faq'),
//             path: `${i18n.language}/bloglist`,
//         },
//         {
//             id: '/FAQ',
//             name: t('navBar.faq'),
//             path: `${i18n.language}/FAQ`,
//         },
//         {
//             id: '/rascoin',
//             name: `Rascoin`,
//             path: `${i18n.language}/rascoin`,
//         },
//         {
//             id: '/pros',
//             name: t('navBar.pros'),
//             path: `${i18n.language}/pros`,
//             click: true,
//         }
//     ];
//     const HeartbeatPinDropIcon = styled('div')`
//         @keyframes heartbeat {
//             0% {
//             transform: scale(1);
//             box-shadow: 0 0 0 rgba(0, 0, 0, 0);
//             }
//             50% {
//             transform: scale(1.1);
//             box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
//             }
//             100% {
//             transform: scale(1);
//             box-shadow: 0 0 0 rgba(0, 0, 0, 0);
//             }
//         }

//         animation: heartbeat 1.5s infinite;
//         border-radius: 50%;
//         `;

//     const { isAuthenticated, role } = useSelector((state: RootState) => state.auth);
//     const { isPro } = useSelector((state: RootState) => state.auth);
//     const { notificationSource } = useSelector((state: RootState) => state.messageSource)

//     const { dataProfile } = useSelector((state: RootState) => state.profile);

//     const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
//     const [openProfileMenu, setOpenProfileMenu] = useState<null | HTMLElement>(null);

//     const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => {
//         setAnchorElNav(event.currentTarget);
//     };

//     const handleCloseNavMenu = () => {
//         setAnchorElNav(null);
//     };

//     const handleOpenProfileMenu = (event: MouseEvent<HTMLElement>) => {
//         if (openProfileMenu === null) {
//             setOpenProfileMenu(event.currentTarget);
//         } else {
//             setOpenProfileMenu(null);
//         }
//     };

//     const changeLanguage = useChangeLanguage();

//     return (
//         <AppBar position="sticky"
//             sx={{
//                 // backgroundColor: '#ffffff',
//                 backgroundColor: "#F9FAFB",
//                 boxShadow: 'none'
//             }}>
//             <Container maxWidth="xl">
//                 <Toolbar disableGutters>
//                     <Link to={`/${i18n.language}`} style={{ textDecoration: 'none' }}>
//                         {/* <img
//                             src={imgIcon} // Replace with your image URL
//                             alt="icon"
//                             style={{
//                                 width: 34,
//                                 height: 34, // Matches MUI icon size
//                                 // marginTop: '6px',
//                             }}
//                         /> */}
//                         <Box
//                             sx={{
//                                 width: 34,
//                                 height: 34,
//                                 background: 'linear-gradient(135deg, #2a0647, #7223b5)',
//                                 WebkitMaskImage: `url(${imgIcon})`,
//                                 WebkitMaskRepeat: 'no-repeat',
//                                 WebkitMaskSize: 'cover',
//                                 maskImage: `url(${imgIcon})`,
//                                 maskRepeat: 'no-repeat',
//                                 maskSize: 'cover',
//                             }}
//                         />
//                     </Link>
//                     {(!isAuthenticated || !isSmallScreen) &&
//                         <Typography
//                             variant="h6"
//                             noWrap
//                             component="a"
//                             href={`/${i18n.language}`}
//                             sx={{
//                                 mr: 2,
//                                 // ml: 1,
//                                 display: 'flex',
//                                 fontFamily: 'monospace',
//                                 scale: '1.2',
//                                 fontWeight: 700,
//                                 color: 'linear-gradient(135deg, #581c87, #a855f7)',
//                                 // letterSpacing: '.3rem',
//                                 textDecoration: 'none',
//                             }}
//                         >
//                             {/* <PixIcon /> */}
//                             astcom
//                         </Typography>
//                     }
//                     {isSmallScreen && <Box sx={{ marginLeft: '50px' }}>
//                         <Link to={pages[5].path} key={pages[5].id}>
//                             {isAuthenticated ?
//                                 <PinDropIcon sx={{ fontSize: 40 }} color='success'></PinDropIcon>
//                                 :
//                                 <HeartbeatPinDropIcon>
//                                     <PinDropIcon sx={{ fontSize: 40 }} color='success'></PinDropIcon>
//                                 </HeartbeatPinDropIcon>
//                             }
//                         </Link>
//                     </Box>}
//                     <MyMenu />
//                     <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
//                         <MobileMenu pages={pages} anchorElNav={anchorElNav} handleCloseNavMenu={handleCloseNavMenu} />
//                     </Box>
//                     <Box sx={{
//                         flexGrow: 1,
//                         display: { xs: 'none', md: 'flex' },
//                         alignItems: "center"
//                     }}>
//                         {pages
//                             .filter((page) => page.id !== '/bloglist' && page.id !== '/FAQ') // Filter out "Blog"
//                             .map((page) => (
//                                 <Link to={page.path} key={page.id}>
//                                     <Button
//                                         // variant={page.id === '/rascoin' ? 'outlined' : undefined}
//                                         onClick={() => {
//                                             handleCloseNavMenu();
//                                         }}
//                                         sx={{
//                                             my: 2,
//                                             color: '#6B7280',
//                                             display: 'block',
//                                             textTransform: 'capitalize',
//                                             marginTop: page.id === '/pros' ? '0.5rem' : undefined,
//                                         }}
//                                     >
//                                         {page.name}
//                                         {page.id === '/pros' && <PinDropIcon sx={{ paddingTop: 0, marginTop: 0 }} />}
//                                     </Button>
//                                 </Link>
//                             ))}

//                         {
//                             role === "admin"
//                                 ?
//                                 <Link to={`${i18n.language}/admin`}>
//                                     <MyBtn mobile={false}>
//                                         admin
//                                     </MyBtn>
//                                 </Link>
//                                 :
//                                 null
//                         }
//                     </Box>
//                     {
//                         isAuthenticated ?
//                             <>
//                                 <Link to={`${i18n.language}/notification`}>
//                                     <Badge badgeContent={notificationSource} color="secondary" sx={{
//                                         '& .MuiBadge-badge': {
//                                             right: 6,
//                                             top: 2,
//                                         }
//                                     }}>
//                                         <NotificationsIcon sx={{ color: "#1e905d", marginRight: 2 }} />
//                                     </Badge>
//                                 </Link>
//                                 <Button
//                                     aria-label="more"
//                                     aria-controls="long-menu"
//                                     aria-haspopup="true"
//                                     onClick={handleOpenProfileMenu}
//                                     endIcon={openProfileMenu ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
//                                 >
//                                     <Badge
//                                         badgeContent={isPro ? <VerifiedIcon sx={{ color: "#1e905d" }} /> : null}
//                                         sx={{
//                                             '& .MuiBadge-badge': {
//                                                 right: -5,
//                                                 top: 2,
//                                             }
//                                         }}
//                                     >
//                                         <Avatar
//                                             alt={"name"}
//                                             src={dataProfile?.userPhoto !== null ? dataProfile?.userPhoto : avatar_img}
//                                             sx={{ width: 35, height: 35 }}
//                                         />
//                                         <ProfileMenu openProfileMenu={openProfileMenu}
//                                             setOpenProfileMenu={setOpenProfileMenu} />
//                                     </Badge>
//                                 </Button>
//                             </>
//                             :
//                             <>
//                                 <Link to={`${i18n.language}/login`}>
//                                     <Button variant="outlined"
//                                         sx={{
//                                             color: '#000000',
//                                             border: '1px solid #D1D5DB',
//                                             borderRadius: '20px',
//                                             textTransform: 'capitalize',
//                                             margin: 2,
//                                             fontSize: 12,
//                                             display: { xs: 'none', md: 'flex' }
//                                         }}
//                                     >
//                                         {t('navBar.signIn')}
//                                     </Button>
//                                 </Link>
//                                 <Link to={`${i18n.language}/signup`}>
//                                     {/* <MyBtn mobile={true}>
//                                         {t('navBar.singUp')}
//                                     </MyBtn> */}
//                                     <Button
//                                         variant="contained"
//                                         sx={{
//                                             background: 'linear-gradient(135deg, #3b0764, #9333ea)', // 💜 luxury dark purple
//                                             color: '#FFFFFF',
//                                             border: 'none',
//                                             borderRadius: '20px',
//                                             textTransform: 'capitalize',
//                                             fontSize: 12,
//                                             display: { xs: 'none', md: 'flex' },
//                                             boxShadow: '0 0 16px rgba(147, 51, 234, 0.4)', // ✨ glow
//                                             transition: 'all 0.3s ease',

//                                             '&:hover': {
//                                                 background: 'linear-gradient(135deg, #581c87, #a855f7)',
//                                                 boxShadow: '0 0 22px rgba(147, 51, 234, 0.6)',
//                                             },
//                                         }}
//                                     >
//                                         {t('navBar.singUp')}
//                                     </Button>

//                                 </Link>
//                             </>
//                     }
//                     <Box sx={{
//                         display: 'flex',
//                     }}>
//                         <IconButton
//                             onClick={changeLanguage}
//                             size="small"
//                             aria-label="account of current user"
//                             aria-controls="menu-appbar"
//                             aria-haspopup="true"
//                             // color="inherit"
//                             sx={{
//                                 color: '#9D00FF',
//                                 display: { xs: 'none', md: 'flex' },
//                                 fontSize: "13px",
//                                 padding: '13px',
//                             }}
//                         >
//                             <LanguageOutlinedIcon />
//                             {i18n.language === "en" ? 'FR' : "EN"}
//                         </IconButton>
//                         <IconButton
//                             size="large"
//                             aria-label="account of current user"
//                             aria-controls="menu-appbar"
//                             aria-haspopup="true"
//                             onClick={handleOpenNavMenu}
//                             color="inherit"
//                             sx={{
//                                 color: '#9CA3AF',
//                                 display: { xs: 'flex', md: 'none' }
//                             }}
//                         >
//                             <MenuIcon />
//                         </IconButton>
//                     </Box>
//                 </Toolbar>
//             </Container>
//         </AppBar>
//     );
// }




import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { MyMenu } from "./MyMenu/MyMenu";
import MyBtn from "../../UI/MyBtn/MyBtn";
import { MobileMenu } from "./MobileMenu/MobileMenu";
import { Link, useLocation } from 'react-router-dom';
import { Avatar, Badge, Theme, useMediaQuery } from "@mui/material";
import avatar_img from "../../../public/avatar.png";
import { ProfileMenu } from "./ProfileMenu/ProfileMenu";
import { useSelector } from 'react-redux';
import { RootState } from "../../../store/store";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import React, { useState, MouseEvent } from 'react';
import VerifiedIcon from "@mui/icons-material/Verified";
import { useTranslation } from 'react-i18next';
import useChangeLanguage from "../../../hooks/useChangeLanguage";
import PinDropIcon from '@mui/icons-material/PinDrop';
import { styled } from '@mui/system';
import imgIcon from '../../../public/main/R.svg'

export const NavBar = () => {
    const { t, i18n } = useTranslation();
    const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
    const location = useLocation();
    // const isRascoinPage = location.pathname.endsWith("/rascoin"); // check if we are on rascoin
    const isRascoinPage = true

    const pages = [
        { id: '/about', name: t('navBar.about'), path: `${i18n.language}/about` },
        { id: `/pricing`, name: t('navBar.pricing'), path: `${i18n.language}/pricing` },
        { id: '/bloglist', name: "Blog", path: `${i18n.language}/bloglist` },
        { id: '/FAQ', name: t('navBar.faq'), path: `${i18n.language}/FAQ` },
        { id: '/rascoin', name: `Rascoin`, path: `${i18n.language}/rascoin` },
        { id: '/pros', name: t('navBar.pros'), path: `${i18n.language}/pros`, click: true },
    ];

    const HeartbeatPinDropIcon = styled('div')`
        @keyframes heartbeat {
            0% { transform: scale(1); box-shadow: 0 0 0 rgba(0,0,0,0); }
            50% { transform: scale(1.1); box-shadow: 0 0 20px rgba(0,0,0,0.5); }
            100% { transform: scale(1); box-shadow: 0 0 0 rgba(0,0,0,0); }
        }
        animation: heartbeat 1.5s infinite;
        border-radius: 50%;
    `;

    const { isAuthenticated, role } = useSelector((state: RootState) => state.auth);
    const { isPro } = useSelector((state: RootState) => state.auth);
    const { notificationSource } = useSelector((state: RootState) => state.messageSource)
    const { dataProfile } = useSelector((state: RootState) => state.profile);

    const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
    const [openProfileMenu, setOpenProfileMenu] = useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => setAnchorElNav(event.currentTarget);
    const handleCloseNavMenu = () => setAnchorElNav(null);
    const handleOpenProfileMenu = (event: MouseEvent<HTMLElement>) => setOpenProfileMenu(openProfileMenu ? null : event.currentTarget);

    const changeLanguage = useChangeLanguage();

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                background: isRascoinPage
                    ? "#112240" // 🌙 dark luxury
                    : "#F9FAFB",
                color: isRascoinPage ? "#E6E6E6" : "inherit",
                // boxShadow: isRascoinPage
                //     ? "0 0 20px rgba(0,0,0,0.6)"
                //     : "none",
                transition: "all 0.3s ease",
            }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Link to={`/${i18n.language}`} style={{ textDecoration: 'none' }}>
                        <Box
                            sx={{
                                width: 34,
                                height: 34,
                                background: "#64FFDA",
                                // background: isRascoinPage
                                //     ? "linear-gradient(135deg, #9333ea)" // purple glow
                                //     : "linear-gradient(135deg,  #7223b5)",
                                WebkitMaskImage: `url(${imgIcon})`,
                                WebkitMaskRepeat: 'no-repeat',
                                WebkitMaskSize: 'cover',
                                maskImage: `url(${imgIcon})`,
                                maskRepeat: 'no-repeat',
                                maskSize: 'cover',
                            }}
                        />
                    </Link>
                    {(!isAuthenticated || !isSmallScreen) &&
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href={`/${i18n.language}`}
                            sx={{
                                mr: 2,
                                display: 'flex',
                                fontFamily: 'monospace',
                                scale: '1.2',
                                fontWeight: 700,
                                background: "#64FFDA",
                                // background: isRascoinPage
                                //     ? "linear-gradient(135deg, #c084fc, #a855f7)"
                                //     : "linear-gradient(135deg, #581c87, #a855f7)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                textDecoration: 'none',
                            }}
                        >
                            astcom
                        </Typography>
                    }
                    {isSmallScreen && <Box sx={{ marginLeft: '50px' }}>
                        <Link to={pages[5].path} key={pages[5].id}>
                            {isAuthenticated ?
                                <PinDropIcon sx={{ fontSize: 40 }} color='success' />
                                :
                                <HeartbeatPinDropIcon>
                                    <PinDropIcon sx={{ fontSize: 40 }} color='success' />
                                </HeartbeatPinDropIcon>
                            }
                        </Link>
                    </Box>}
                    <MyMenu />
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <MobileMenu pages={pages} anchorElNav={anchorElNav} handleCloseNavMenu={handleCloseNavMenu} />
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, alignItems: "center" }}>
                        {pages
                            .filter((page) => page.id !== '/bloglist' && page.id !== '/FAQ')
                            .map((page) => (
                                <Link to={page.path} key={page.id}>
                                    <Button
                                        onClick={handleCloseNavMenu}
                                        sx={{
                                            my: 2,
                                            color: isRascoinPage ? "#64FFDA" : "#6B7280",
                                            display: 'block',
                                            textTransform: 'capitalize',
                                            marginTop: page.id === '/pros' ? '0.5rem' : undefined,
                                            "&:hover": isRascoinPage
                                                ? { color: "#A78BFA" }
                                                : { color: "#4B5563" }
                                        }}
                                    >
                                        {page.name}
                                        {page.id === '/pros' && <PinDropIcon sx={{ paddingTop: 0, marginTop: 0 }} />}
                                    </Button>
                                </Link>
                            ))}

                        {role === "admin" &&
                            <Link to={`${i18n.language}/admin`}>
                                <MyBtn mobile={false}>admin</MyBtn>
                            </Link>
                        }
                    </Box>
                    {isAuthenticated ? (
                        <>
                            <Link to={`${i18n.language}/notification`}>
                                <Badge badgeContent={notificationSource} color="secondary" sx={{ '& .MuiBadge-badge': { right: 6, top: 2 } }}>
                                    <NotificationsIcon sx={{ color: isRascoinPage ? "#A78BFA" : "#1e905d", marginRight: 2 }} />
                                </Badge>
                            </Link>
                            <Button
                                aria-label="more"
                                aria-controls="long-menu"
                                aria-haspopup="true"
                                onClick={handleOpenProfileMenu}
                                endIcon={openProfileMenu ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            >
                                <Badge
                                    badgeContent={isPro ? <VerifiedIcon sx={{ color: "#1e905d" }} /> : null}
                                    sx={{ '& .MuiBadge-badge': { right: -5, top: 2 } }}
                                >
                                    <Avatar
                                        alt={"name"}
                                        src={dataProfile?.userPhoto !== null ? dataProfile?.userPhoto : avatar_img}
                                        sx={{ width: 35, height: 35 }}
                                    />
                                    <ProfileMenu openProfileMenu={openProfileMenu} setOpenProfileMenu={setOpenProfileMenu} />
                                </Badge>
                            </Button>
                        </>
                    ) : (
                        <>
                            <Link to={`${i18n.language}/login`}>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        color: isRascoinPage ? "#E5E7EB" : "#000000",
                                        border: '1px solid #D1D5DB',
                                        borderRadius: '20px',
                                        textTransform: 'capitalize',
                                        margin: 2,
                                        fontSize: 12,
                                        display: { xs: 'none', md: 'flex' }
                                    }}
                                >
                                    {t('navBar.signIn')}
                                </Button>
                            </Link>
                            <Link to={`${i18n.language}/signup`}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        background: isRascoinPage
                                            ? "linear-gradient(135deg, #9333ea, #3b0764)"
                                            : "linear-gradient(135deg, #3b0764, #9333ea)",
                                        color: '#FFFFFF',
                                        borderRadius: '20px',
                                        textTransform: 'capitalize',
                                        fontSize: 12,
                                        display: { xs: 'none', md: 'flex' },
                                        boxShadow: isRascoinPage
                                            ? "0 0 22px rgba(147, 51, 234, 0.6)"
                                            : "0 0 16px rgba(147, 51, 234, 0.4)",
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            background: "linear-gradient(135deg, #581c87, #a855f7)",
                                            boxShadow: "0 0 24px rgba(147, 51, 234, 0.7)",
                                        },
                                    }}
                                >
                                    {t('navBar.singUp')}
                                </Button>
                            </Link>
                        </>
                    )}
                    <Box sx={{ display: 'flex' }}>
                        <IconButton
                            onClick={changeLanguage}
                            size="small"
                            sx={{
                                color: isRascoinPage ? "#A78BFA" : "#9D00FF",
                                display: { xs: 'none', md: 'flex' },
                                fontSize: "13px",
                                padding: '13px',
                            }}
                        >
                            <LanguageOutlinedIcon />
                            {i18n.language === "en" ? 'FR' : "EN"}
                        </IconButton>
                        <IconButton
                            size="large"
                            onClick={handleOpenNavMenu}
                            sx={{
                                color: isRascoinPage ? "#E5E7EB" : "#9CA3AF",
                                display: { xs: 'flex', md: 'none' }
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
